import EventClass from "common/utils/ui/event-class";

// eslint-disable-next-line import/prefer-default-export
export class ProductsFilterModalSubmitClass extends EventClass {
  #props;

  constructor(props) {
    super(props);

    this.#props = props;

    // Fix for the issue where the page is loaded from cache
    window.addEventListener("pageshow", event => {
      if (event.persisted) {
        this.enableButtons();
      }
    });
  }

  get #$buttons() {
    return document.querySelectorAll(this.#props.eventSelector);
  }

  disableButtons() {
    this.#$buttons.forEach($submit => {
      $submit.setAttribute("disabled", "disabled");
    });
  }

  enableButtons() {
    this.#$buttons.forEach($submit => {
      $submit.removeAttribute("disabled");
    });
  }

  event(event, $target) {
    super.event(event, $target);
    this.disableButtons();
  }
}
